import { SVGProps } from "react"

export const CreditCardEditIcon: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className="stroke-fg-1"
      {...props}>
      <path
        d="M2.33203 8.33366H18.9987V6.83366C18.9987 5.90024 18.9987 5.43353 18.817 5.07701C18.6573 4.76341 18.4023 4.50844 18.0887 4.34865C17.7322 4.16699 17.2655 4.16699 16.332 4.16699H4.9987C4.06528 4.16699 3.59857 4.16699 3.24205 4.34865C2.92844 4.50844 2.67348 4.7634 2.51369 5.07701C2.33203 5.43353 2.33203 5.90024 2.33203 6.83366V13.167C2.33203 14.1004 2.33203 14.5671 2.51369 14.9236C2.67348 15.2372 2.92844 15.4922 3.24205 15.652C3.59857 15.8337 4.06528 15.8337 4.9987 15.8337H9.83203M12.7487 17.5003L14.4362 17.1628C14.5833 17.1334 14.6569 17.1187 14.7255 17.0918C14.7864 17.0679 14.8442 17.0369 14.8979 16.9995C14.9583 16.9574 15.0114 16.9043 15.1175 16.7982L18.582 13.3337C19.0423 12.8734 19.0423 12.1272 18.582 11.667C18.1218 11.2068 17.3756 11.2068 16.9154 11.667L13.4508 15.1315C13.3447 15.2376 13.2917 15.2907 13.2495 15.3511C13.2121 15.4048 13.1811 15.4627 13.1572 15.5235C13.1303 15.5921 13.1156 15.6657 13.0862 15.8129L12.7487 17.5003Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
